import { render } from "./Guest.vue?vue&type=template&id=67350c9e"
import script from "./Guest.vue?vue&type=script&lang=js"
export * from "./Guest.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__